import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FilePdfOutlined,
  FlagFilled,
  FlagOutlined,
  HolderOutlined,
  MenuOutlined,
  PlusCircleOutlined,
  ProfileOutlined,
  ReadOutlined,
  SettingOutlined,
  SolutionOutlined,
  UserAddOutlined,
  VideoCameraOutlined,
  WomanOutlined,
  FolderOpenOutlined,
  MoneyCollectOutlined,
  StarFilled,
  StarOutlined,
  LockOutlined,
  SearchOutlined,
  BellOutlined,
} from "@ant-design/icons";

import Headers from "../components/Header";
import Footers from "../components/Footer";
import Tabbar from "../components/Tabbar";
import logo from "../images/logo.png";
import "../index.css";

// ----------------- MENU CONFIG -----------------
const menuItems = [
  // AZ
  { group: "AZ", permission: "canSeeSectionsGuidesAz", label: "Bələdçilər az", desc: "Bələdçilər siyahısı", icon: <FlagOutlined />, link: "../Tables", keywords: ["guide", "bələdçi"] },
  { group: "AZ", permission: "canSeeSectionsGuidesAzAdd", label: "Yeni Bələdçi", desc: "Yeni bələdçi əlavə et", icon: <PlusCircleOutlined />, link: "../ADD", keywords: ["add", "yeni"] },
  { group: "AZ", permission: "canSeeSectionsGuidesAz", label: "Bütün bələdçi az", desc: "Hamısı (AZ)", icon: <FlagFilled />, link: "../All", keywords: ["all", "hamısı"] },
  { group: "AZ", permission: "canSeeSectionsStafAZ", label: "Staff Az", desc: "Personal siyahısı", icon: <SolutionOutlined />, link: "/personal", keywords: ["staff", "personal"] },
  { group: "AZ", permission: "canSeeSectionsStafAZAdd", label: "Yeni Staff Az", desc: "Yeni personal əlavə et", icon: <UserAddOutlined />, link: "/AddPersonal", keywords: ["staff", "add"] },
  { group: "AZ", permission: "canSeeSectionsMenuPdfAZ", label: "Menu PDF AZ", desc: "Menu PDF idarəetmə", icon: <ProfileOutlined />, link: "/MenuPdf", keywords: ["menu", "pdf"] },
  { group: "AZ", permission: "canSeeSectionsMenuazAdd", label: "Menu Add AZ", desc: "Menu item əlavə et", icon: <MenuOutlined />, link: "/menuAdd", keywords: ["menu", "add"] },
  { group: "AZ", permission: "canSeeSectionsMenuAZ", label: "Menu AZ", desc: "Menu siyahısı", icon: <ReadOutlined />, link: "/Tablemenu", keywords: ["menu"] },
  { group: "AZ", permission: "canSeeSectionsUzv", label: "Yeni Üzv", desc: "Abunəçi əlavə et", icon: <UserAddOutlined />, link: "/üzv", keywords: ["üzv", "abone"] },
  { group: "AZ", permission: "canSeeSectionsUzvAboneAdd", label: "Üzvlər", desc: "Abunəçilər cədvəli", icon: <WomanOutlined />, link: "/üzvTable", keywords: ["üzv", "table"] },
  { group: "AZ", permission: "canSeeSectionsHesabatMain", label: "Hesabat", desc: "Maliyyə & statistika", icon: <MoneyCollectOutlined />, link: "/hesabat", keywords: ["hesabat", "report"] },
  { group: "AZ", permission: "canSeeSectionsMap", label: "Rezervlər", desc: "Rezerv idarəetmə", icon: <HolderOutlined />, link: "/mapmain", keywords: ["rezerv", "map"] },

  // Mezze
  { group: "Mezze", permission: "canSeeSectionsMenuGeo", label: "Menu PDF Mezze", desc: "Mezze PDF", icon: <ProfileOutlined />, link: "/MenuGeu", keywords: ["mezze", "pdf"] },
  { group: "Mezze", permission: "canSeeSectionsMenuGeo", label: "Menu Add Mezze", desc: "Mezze menu əlavə", icon: <MenuOutlined />, link: "/NewMenuGeo", keywords: ["mezze", "add"] },
  { group: "Mezze", permission: "canSeeSectionsMenuGeo", label: "Menu Mezze", desc: "Mezze menu cədvəli", icon: <ProfileOutlined />, link: "/MenugeoTable", keywords: ["mezze", "menu"] },

  // Europe
  { group: "Europe", permission: "canSeeSectionsMenuEurop", label: "Menu PDF Europe", desc: "Europe PDF", icon: <ProfileOutlined />, link: "/MenuPdfEurop", keywords: ["europe", "pdf"] },
  { group: "Europe", permission: "canSeeSectionsMenuEurop", label: "Menu Add Europe", desc: "Europe menu əlavə", icon: <MenuOutlined />, link: "/MenuADDEurop", keywords: ["europe", "add"] },
  { group: "Europe", permission: "canSeeSectionsMenuEurop", label: "Menu Europe", desc: "Europe menu cədvəli", icon: <ProfileOutlined />, link: "/TablemenuEurop", keywords: ["europe", "menu"] },

  // General
  { group: "General", permission: null, label: "PDF Yüklə", desc: "PDF upload", icon: <FilePdfOutlined />, link: "/DownloafPdf", keywords: ["pdf", "upload"] },
  { group: "General", permission: null, label: "Camera", desc: "Webcam modul", icon: <VideoCameraOutlined />, link: "/Webcam", keywords: ["camera"] },
  { group: "General", permission: "canSeeSectionsInventory", label: "Inventory", desc: "Anbar sistemi", icon: <FolderOpenOutlined />, link: "/inventory", keywords: ["inventory", "anbar"] },
  { group: "General", permission: null, label: "Setting", desc: "Sistem ayarları", icon: <SettingOutlined />, link: "/Settings", keywords: ["setting", "ayar"] },
  { group: "General", permission: null, label: "Bildirişlər", desc: "FCM bildiriş göndər", icon: <BellOutlined />, link: "/notifications", keywords: ["notification", "bildiriş", "fcm", "push"] },
];

// ----------------- helpers -----------------
const LS_FAV = "mainMenu_favorites_v1";
const safeParse = (v, fallback) => {
  try {
    const x = JSON.parse(v);
    return x ?? fallback;
  } catch {
    return fallback;
  }
};
const norm = (s) => (s || "").toString().toLowerCase().trim();

export default function MainMenuSimple() {
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState({});
  const [query, setQuery] = useState("");
  const [group, setGroup] = useState("All");
  const [favorites, setFavorites] = useState(() => safeParse(localStorage.getItem(LS_FAV), []));

  useEffect(() => {
    if (!localStorage.getItem("username")) navigate("/");
    const stored = safeParse(localStorage.getItem("permissions"), []);
    if (stored?.length > 0) setPermissions(stored[0] || {});
  }, [navigate]);

  // --- permission gates (sənin sisteminə uyğun)
  const gates = useMemo(() => {
    const p = permissions || {};
    return {
      canSeeSectionsGuidesAz: p.GuidesAz === 1,
      canSeeSectionsInventory: p.Inventory === 1,
      canSeeSectionsGuidesAzAdd: p.GuidesAzAdd === 1,
      canSeeSectionsStafAZ: p.StafAz === 1,
      canSeeSectionsStafAZAdd: p.StafAzAdd === 1,
      canSeeSectionsMenuAZ: p.Menuaz === 1,
      canSeeSectionsMenuPdfAZ: p.MenuPdfAZ === 1,
      canSeeSectionsMenuazAdd: p.MenuazAdd === 1,
      canSeeSectionsMenuGeo: p.MenuGeo === 1,
      canSeeSectionsMenuEurop: p.MenuEurop === 1,
      canSeeSectionsUzv: p.Abone === 1,
      canSeeSectionsUzvAboneAdd: p.AboneAdd === 1,
      canSeeSectionsMap: p.Rezerv === 1,
      canSeeSectionsHesabatMain: p.HesabatMain === 1,
    };
  }, [permissions]);

  const can = (key) => (key ? !!gates[key] : true);

  const favSet = useMemo(() => new Set(favorites || []), [favorites]);

  const allowed = useMemo(() => menuItems.filter((i) => can(i.permission)), [gates]);
  const allGroups = useMemo(() => ["All", ...Array.from(new Set(allowed.map((i) => i.group)))], [allowed]);

  const visible = useMemo(() => {
    const q = norm(query);
    return allowed.filter((i) => {
      const byGroup = group === "All" || i.group === group;
      if (!byGroup) return false;
      if (!q) return true;
      const hay = norm([i.label, i.desc, i.group, ...(i.keywords || [])].join(" "));
      return hay.includes(q);
    });
  }, [allowed, query, group]);

  const favItems = useMemo(() => allowed.filter((i) => favSet.has(i.link)), [allowed, favSet]);

  const toggleFavorite = (link) => {
    const set = new Set(favorites || []);
    set.has(link) ? set.delete(link) : set.add(link);
    const next = Array.from(set);
    setFavorites(next);
    localStorage.setItem(LS_FAV, JSON.stringify(next));
  };

  const CardTile = ({ item }) => {
    const locked = !can(item.permission); // allowed-da yoxdur, amma gələcək üçün saxladım
    const fav = favSet.has(item.link);

    return (
      <div
        className={`relative rounded-2xl border bg-white p-5 shadow-sm transition
          ${locked ? "opacity-60 cursor-not-allowed border-slate-200" : "border-slate-200 hover:shadow-md hover:-translate-y-0.5"}
        `}
      >
<button
  type="button"
  onClick={(e) => {
    e.stopPropagation();     // kartın navigate klikini blokla
    toggleFavorite(item.link);
  }}
  className={`absolute right-3 top-3 h-9 w-9 rounded-xl border flex items-center justify-center transition
    ${fav ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50"}
  `}
  title={fav ? "Favoritdən çıxar" : "Favorit et"}
>
  {fav ? <StarFilled /> : <StarOutlined />}
</button>

        <div className="flex items-start gap-3">
          <div className="flex items-center justify-center h-11 w-11 rounded-xl bg-slate-100 text-slate-700 ring-1 ring-slate-200">
            {item.icon}
          </div>
          <div className="min-w-0">
            <div className="font-semibold truncate text-slate-900">{item.label}</div>
            <div className="text-slate-500 text-sm mt-0.5 line-clamp-2">{item.desc}</div>
            <div className="inline-flex items-center gap-2 mt-3">
              <span className="text-xs rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-slate-600">
                {item.group}
              </span>
            </div>
          </div>
        </div>

        {locked && (
          <div className="inline-flex items-center gap-2 mt-4 text-xs text-slate-500">
            <LockOutlined /> İcazə yoxdur
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* header */}
      <header className="sticky top-0 z-40 border-b bg-white/85 backdrop-blur border-slate-200">
        <div className="flex items-center justify-between px-4 py-3 mx-auto max-w-7xl">
          <Link to="/Main" className="flex items-center gap-3">
            <img src={logo} alt="Logo" className="w-auto h-9" />
            <div className="hidden sm:block">
              <div className="font-semibold text-slate-900">Panel</div>
            </div>
          </Link>
          <Headers />
        </div>

        {/* toolbar */}
        <div className="px-4 pb-4 mx-auto max-w-7xl">
          <div className="p-4 bg-white border shadow-sm rounded-2xl border-slate-200">
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              {/* search */}
              <div className="relative w-full md:max-w-md">
                <span className="absolute -translate-y-1/2 left-3 top-1/2 text-slate-400">
                  <SearchOutlined />
                </span>
                <input
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Axtar: menu, staff, hesabat..."
                  className="w-full rounded-xl border border-slate-200 bg-white pl-10 pr-3 py-2.5 text-slate-800 outline-none
                             focus:ring-4 focus:ring-slate-200 focus:border-slate-400"
                />
              </div>

              {/* group pills */}
              <div className="flex flex-wrap gap-2">
                {allGroups.map((g) => {
                  const active = group === g;
                  return (
                    <button
                      key={g}
                      onClick={() => setGroup(g)}
                      className={`rounded-full px-3.5 py-1.5 text-sm border transition ${
                        active ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50"
                      }`}
                    >
                      {g}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* favorites row */}
            <div className="mt-4">
              <div className="mb-2 text-sm font-semibold text-slate-900">Favorites</div>
              {favItems.length === 0 ? (
                <div className="text-sm text-slate-500">Hələ favorit seçməmisən. Kartların üstündə ★ bas.</div>
              ) : (
                <div className="flex flex-wrap gap-2">
                  {favItems.slice(0, 10).map((item) => (
                    <button
                      key={item.link}
                      onClick={() => navigate(item.link)}
                      className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-50 transition"
                      title={item.desc}
                    >
                      <span className="text-slate-500">{item.icon}</span>
                      <span className="font-medium">{item.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* grid */}
      <main className="px-4 py-8 mx-auto max-w-7xl">
        {visible.length === 0 ? (
          <div className="p-8 bg-white border rounded-2xl border-slate-200 text-slate-600">
            Axtarış nəticəsi yoxdur.
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
{visible.map((item) => (
  <div
    key={`${item.group}-${item.link}`}
    role="link"
    tabIndex={0}
    onClick={() => navigate(item.link)}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        navigate(item.link);
      }
    }}
    className="block cursor-pointer"
  >
    <CardTile item={item} />
  </div>
))}

          </div>
        )}
      </main>

      <Tabbar />
      <Footers />
    </div>
  );
}
